import { Fragment, useEffect, useState } from 'react';
import { Workbox } from './Workbox';
import { useApi } from '@backstage/core-plugin-api';
import {
  Announcement,
  announcementsApiRef,
  AnnouncementsList,
} from './types/announcements';
import { WorkBoxItem } from './WorkboxItem';
import { Progress } from '@backstage/core-components';
import { DevHubAlert } from '@devxdiscover/devhub-ui';

/**
 * Custom MyNews component
 * @constructor
 */
export const MyNews = () => {
  const [showMore] = useState(false);
  const [showMoreMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const announcementsApi = useApi(announcementsApiRef);
  const [announcements, setAnnouncements] = useState<AnnouncementsList | null>(
    null,
  );

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await announcementsApi.announcements({ max: 10 });
        setAnnouncements(response);
      } finally {
        setLoading(false);
      }
    };

    fetchAnnouncements();
  }, [announcementsApi]);

  const title = 'My News';

  return (
    <Workbox
      consistentHeight
      color="green"
      title={title}
      info=""
      component="news"
      subHeader="Here's what's going on in the community"
      buttonTitle={showMoreMessage}
      showButton={showMore}
    >
      <Fragment>
        {loading && <Progress />}
        {announcements?.results && announcements.results.length === 0 && (
          <DevHubAlert severity="info">
            There are no announcements at this time.
          </DevHubAlert>
        )}
        {announcements?.results &&
          announcements.results.map((announcement: Announcement) => (
            <WorkBoxItem
              key={announcement.id}
              title={announcement.title}
              date={new Date(announcement.created_at)}
              link={`announcements/view/${announcement.id}`}
              body={announcement.excerpt}
            />
          ))}
      </Fragment>
    </Workbox>
  );
};
